import { render, staticRenderFns } from "./install_person.vue?vue&type=template&id=1e943ab6&"
import script from "./install_person.vue?vue&type=script&lang=js&"
export * from "./install_person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports